<template>
    <fade-left-animation :element="() => $refs.section">
        <section class="link-cards-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <div class="header">
                        <h2 class="heading h1">{{ title }}</h2>
                    </div>

                    <base-carousel
                        navigation
                        center-insufficient-slides
                        :breakpoints="breakpoints"
                        :always-show-navigation="showNavigationButtons"
                        ref="carousel"
                    >
                        <div
                            class="card-container"
                            v-for="(slide, i) in slides"
                            :key="slide.name"
                            :slot="`slide_${ slide.name }_${ i }`"
                        >
                            <link-card
                                v-bind="slide"
                            />
                        </div>
                    </base-carousel>
                </mobile-gutter>
            </b-container>
        </section>
    </fade-left-animation>
</template>

<script>
    import BaseCarousel from '../../molecules/BaseCarousel/BaseCarousel';
    import ProductListingCard from '../../molecules/ProductListingCard/ProductListingCard';
    import LinkCard from '../../molecules/LinkCard/LinkCard.vue';

    export default {
        name: 'link-cards-section',

        components: { LinkCard, ProductListingCard, BaseCarousel },

        props: {
            title: {
                type: String,
                required: true,
            },

            slides: {
                type: Array,
                default: () => ([]),
            },

            showNavigationButtons: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            /**
             * If there is only 1 slide in the carousel, ensure on mobile it takes up full width.
             *
             * @returns {object}
             */
            breakpoints() {
                if (this.slides.length !== 1) {
                    return {};
                }

                return {
                    0: {
                        slidesPerView: 1,
                    },
                    576: {
                        slidesPerView: 2,
                    },
                    960: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 4,
                    },
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    .link-cards-section {
        position: relative;
        padding-top: 45px;
        padding-bottom: 45px;
        overflow-x: hidden;

        @include media-breakpoint-up(md) {
            padding-top: 64px;
            padding-bottom: 64px;
        }
    }

    .header {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        justify-content: center;
    }

    .heading {
        text-align: center;
        margin: 0;
        font-size: rem(24px);

        @include media-breakpoint-up(md) {
            font-size: rem(36px);
        }
    }

    .card-container {
        display: flex;
        height: 100%;
    }

    .base-carousel ::v-deep {
        .swiper-slide {
            height: auto;
        }
    }
</style>
